import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import edit from './edit';
import save from './save';
import transforms from './transforms';
import IconBlockData from './block.json';
import blockIcon from './icons/block-icon';
import { getBlockLabelByName } from '@helpers/utils';
import attributeVisibility from '@components/visibility/attributes.json';

const { name, ...settings } = IconBlockData;

const attributes = {
  ...settings.attributes,
  ...attributeVisibility,
};

registerBlockType(name, {
  ...settings,
  transforms,
  icon: blockIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
